var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{attrs:{"row-selection":_vm.rowSelection
        ? {
            selectedRowKeys: _vm.rowSelectionKeys,
            onChange: _vm.onSelectChange,
            getCheckboxProps: function (r) { return ({
              props: { disabled: r.isCheckDisabled }
            }); }
          }
        : null,"columns":_vm.tableColumns,"data-source":_vm.tableData,"scroll":{ x: _vm.scrollX },"pagination":false,"loading":_vm.tableLoading,"row-key":function (record) { return record.id; }},scopedSlots:_vm._u([{key:"action",fn:function(record, index){return _c('div',{},[_vm._t("action",null,{"record":record,"index":index})],2)}}],null,true)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d955e66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a-table-scroll/index.vue
// module id = null
// module chunks = 